/**
 * reachability: entry-point — Sarah visual identity.
 * Matt approved public/images/sarah/avatar.jpg as the final avatar on
 * 2026-10-15. The launcher and Sarah's chat messages both use this path.
 * Swap the file only; do not inline a second photo.
 */
export const SARAH_AVATAR_SRC = '/images/sarah/avatar.jpg' as const
export const SARAH_AVATAR_SRC_2X = '/images/sarah/avatar@2x.jpg' as const
export const SARAH_AVATAR_SRC_3X = '/images/sarah/avatar@3x.jpg' as const
export const SARAH_AVATAR_SRCSET =
  `${SARAH_AVATAR_SRC} 1x, ${SARAH_AVATAR_SRC_2X} 2x, ${SARAH_AVATAR_SRC_3X} 3x` as const
export const SARAH_AVATAR_ALT = 'Sarah, Ryan Realty AI assistant' as const

/** Matt's public headshot, used only when he has taken over a chat. */
export const MATT_CHAT_PHOTO_SRC = '/images/brokers/ryan-matt.png' as const
export const MATT_CHAT_PHOTO_ALT = 'Matt Ryan' as const

/**
 * Animated launcher face (Matt 2026-10-26, "can she be animated like a video",
 * then "Just turn on. She should wave, smile, do the phone to ear sign").
 * Both clips are cut from avatar.jpg with image-to-video, framed a little wider
 * so her hands fit inside the disc, and start and end on the rest pose. The
 * gesture (smile, wave, call-me sign) plays once after idle and at most once
 * more per session; the idle loop (smile and blink) runs between. The still
 * stays the poster and the fallback. This flag turns both off.
 */
export const SARAH_AVATAR_VIDEO_ENABLED: boolean = true
export const SARAH_AVATAR_VIDEO_WEBM = '/images/sarah/loop/idle.webm' as const
export const SARAH_AVATAR_VIDEO_MP4 = '/images/sarah/loop/idle.mp4' as const
export const SARAH_AVATAR_GESTURE_WEBM = '/images/sarah/loop/gesture.webm' as const
export const SARAH_AVATAR_GESTURE_MP4 = '/images/sarah/loop/gesture.mp4' as const
